const nomEntornDevelopment = "dev";
const folder = "fenocat/";
const env = {
  dev: {
    ruta: "",
    api: {
      URL: process.env.REACT_APP_API_URL || "http://localhost:3001"
    },
    S3: {
      url: `https://static-pre.meteo.cat/${folder}`
    },
    mapa: {
      tilesUrl:
        "https://static-pre.meteo.cat/tiles/fons/GoogleMapsCompatible/{z}/000/{dimX}/{x}/000/{dimY}/{y}.png"
    }
  },
  proves: {
    ruta: "",
    api: {
      URL: "https://devnode1.meteocat.com:8588"
    },
    S3: {
      url: `https://static-pre.meteo.cat/${folder}`
    },
    mapa: {
      tilesUrl:
        "https://static-pre.meteo.cat/tiles/fons/GoogleMapsCompatible/{z}/000/{dimX}/{x}/000/{dimY}/{y}.png"
    }
  },
  pre: {
    ruta: "",
    api: {
      URL: "https://xarxes.meteo.cat:8588"
    },
    S3: {
      url: `https://static-pre.meteo.cat/${folder}`
    },
    mapa: {
      tilesUrl:
        "https://static-pre.meteo.cat/tiles/fons/GoogleMapsCompatible/{z}/000/{dimX}/{x}/000/{dimY}/{y}.png"
    }
  },
  pro: {
    ruta: "",
    api: {
      URL: "https://feno.meteocat.gencat.cat:8588"
    },
    S3: {
      url: `https://static-m.meteo.cat/${folder}`
    },
    mapa: {
      tilesUrl:
        "https://static-m.meteo.cat/tiles/fons/GoogleMapsCompatible/{z}/000/{dimX}/{x}/000/{dimY}/{y}.png"
    }
  }
};

const configuracio =
  env[process.env.REACT_APP_ENVIROMENT || nomEntornDevelopment];

export default {
  // Add common config values here, per exemple: MAX_ATTACHMENT_SIZE: 5000000,
  ...configuracio
};
